import { NOTIFICATION_TYPES } from '../config/constants';
import logger from './logger';

export interface ErrorDetails {
  message: string;
  code: string;
  context?: Record<string, unknown>;
}

export interface ErrorNotification {
  message: string;
  type: typeof NOTIFICATION_TYPES[keyof typeof NOTIFICATION_TYPES];
}

const loggerInstance = logger;

export const ERROR_CODES = {
  MARKER: {
    NOT_FOUND: 'MARKER_NOT_FOUND',
    INVALID_OPERATION: 'MARKER_INVALID_OPERATION',
    CATEGORY_UNCHANGED: 'MARKER_CATEGORY_UNCHANGED'
  },
  CATEGORY: {
    NOT_FOUND: 'CATEGORY_NOT_FOUND',
    INVALID_OPERATION: 'CATEGORY_INVALID_OPERATION'
  }
} as const;

export const ERROR_MESSAGES = {
  [ERROR_CODES.MARKER.NOT_FOUND]: 'Le marqueur n\'a pas été trouvé',
  [ERROR_CODES.MARKER.INVALID_OPERATION]: 'Opération invalide sur le marqueur',
  [ERROR_CODES.MARKER.CATEGORY_UNCHANGED]: 'Le marqueur est déjà dans cette catégorie',
  [ERROR_CODES.CATEGORY.NOT_FOUND]: 'La catégorie n\'a pas été trouvée',
  [ERROR_CODES.CATEGORY.INVALID_OPERATION]: 'Opération invalide sur la catégorie'
} as const;

/**
 * Gère une erreur de manière standardisée
 * @param error - Détails de l'erreur
 * @returns Notification à afficher à l'utilisateur
 */
export const handleError = (error: ErrorDetails): ErrorNotification => {
  // Log l'erreur
  loggerInstance.error(error.message, {
    code: error.code,
    context: error.context
  });

  // Retourne la notification
  return {
    message: ERROR_MESSAGES[error.code as keyof typeof ERROR_MESSAGES] || error.message,
    type: NOTIFICATION_TYPES.ERROR
  };
};

/**
 * Crée une notification de succès
 * @param message - Message de succès
 * @returns Notification à afficher à l'utilisateur
 */
export const createSuccessNotification = (message: string): ErrorNotification => ({
  message,
  type: NOTIFICATION_TYPES.SUCCESS
});

/**
 * Crée une notification d'information
 * @param message - Message d'information
 * @returns Notification à afficher à l'utilisateur
 */
export const createInfoNotification = (message: string): ErrorNotification => ({
  message,
  type: NOTIFICATION_TYPES.INFO
});

